import { Action } from 'redux';

export const EXTRACT_FAILURE_NOTIFICATION_OPT_IN_REQUEST = 'EXTRACT_FAILURE_NOTIFICATION_OPT_IN_REQUEST';
export const EXTRACT_FAILURE_NOTIFICATION_OPT_IN_SUCCESS = 'EXTRACT_FAILURE_NOTIFICATION_OPT_IN_SUCCESS';
export const EXTRACT_FAILURE_NOTIFICATION_OPT_IN_FAILURE = 'EXTRACT_FAILURE_NOTIFICATION_OPT_IN_FAILURE';

export const EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_REQUEST = 'EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_REQUEST';
export const EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_SUCCESS = 'EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_SUCCESS';
export const EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_FAILURE = 'EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_FAILURE';

export interface ExtractFailureNotificationAction extends Action {
    id: string;
    contentType: string;
}

export const extractFailureNotificationOptInRequest = (id: string, contentType: string): ExtractFailureNotificationAction => ({
    type: EXTRACT_FAILURE_NOTIFICATION_OPT_IN_REQUEST,
    id,
    contentType,
});

export const extractFailureNotificationOptOutRequest = (id: string, contentType: string): ExtractFailureNotificationAction => ({
    type: EXTRACT_FAILURE_NOTIFICATION_OPT_OUT_REQUEST,
    id,
    contentType,
});
